import React, { useState, useEffect } from "react";
import "./Locations.css";
import MapChart from "./MapChart";
import StateListView from "./StateListView";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { Button, ButtonGroup } from "@heroui/react";
import "react-tooltip/dist/react-tooltip.css";
import CenteredHeroNav from "../components/CenteredHeroNav";

const Locations = () => {
  const [content, setContent] = useState("");
  const [viewMode, setViewMode] = useState("auto"); // auto, map, list

  // Auto-detect mobile on mount
  useEffect(() => {
    const isMobile = window.innerWidth < 768;
    setViewMode(isMobile ? "list" : "map");
  }, []);

  const activeView = viewMode === "auto"
    ? (window.innerWidth < 768 ? "list" : "map")
    : viewMode;

  return (
    <div className="min-h-screen flex flex-col theme-gradient-surface">
      {/* Consistent navbar */}
      <CenteredHeroNav />

      {/* View Toggle */}
      <div className="w-full max-w-7xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold text-default-900">Browse by State</h1>
          <ButtonGroup variant="bordered" size="sm">
            <Button
              onClick={() => setViewMode("map")}
              color={activeView === "map" ? "primary" : "default"}
              className="min-w-[80px]"
            >
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
              </svg>
              Map
            </Button>
            <Button
              onClick={() => setViewMode("list")}
              color={activeView === "list" ? "primary" : "default"}
              className="min-w-[80px]"
            >
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" />
              </svg>
              List
            </Button>
          </ButtonGroup>
        </div>
      </div>

      {/* Content Area */}
      {activeView === "map" ? (
        <div className="flex-1 flex items-center justify-center p-2 md:p-4 lg:p-6 overflow-hidden">
          <div className="w-full max-w-7xl h-full flex items-center justify-center">
            <div
              className="w-full max-h-[calc(100vh-200px)] flex items-center justify-center overflow-hidden rounded-3xl relative map-gradient-container p-4 md:p-6 lg:p-8"
            >
              <div className="absolute inset-0 rounded-3xl map-gradient-overlay"></div>
              <div className="w-full h-full max-w-[min(100%,800px)] max-h-[min(100%,600px)] relative z-10">
                <MapChart setTooltipContent={setContent} />
              </div>
              <ReactTooltip
                offset={{ top: 305, left: 45 }}
                place="left"
                style={{ width: "max-content" }}
              >
                {content}
              </ReactTooltip>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex-1 overflow-auto pb-8">
          <StateListView />
        </div>
      )}
    </div>
  );
};

export default Locations;
